// extracted by mini-css-extract-plugin
module.exports = {"container":"opening-hours-table_container__ouKk9","day":"opening-hours-table_day__E0gi3","hours":"opening-hours-table_hours__k1OQo"};